import axios from 'axios';
import { apiDomain } from '@/config';

import * as types from './types';

const actions = {
  reset: ({ commit }) => {
    commit(types.RESET);
  },
  // Employees
  async fetchEmployees({ rootState, commit }, payload) {
    commit(types.FETCH_EMPLOYEES_PENDING);
    const companyId = payload.companyId || rootState.company.profile.company.id;
    try {
      const baseUrl = `${apiDomain}company/${companyId}/employees`;
      const url = payload && payload.listType ? `${baseUrl}?scope=${payload.listType}` : baseUrl;
      const response = await axios.get(url);
      commit(types.FETCH_EMPLOYEES_FULFILLED, response);
      return true;
    } catch (error) {
      commit(types.FETCH_EMPLOYEES_ERROR);
      return Promise.reject(error);
    }
  },
  async storeEmployee({ commit, dispatch }, { payload, list }) {
    commit(types.STORE_EMPLOYEE_PENDING);
    try {
      const url = `${apiDomain}company/${payload.companyId}/employees/${payload.employee.resume_entry_id}`;
      const response = await axios.patch(url, payload.employee);
      await dispatch('fetchEmployees', payload.companyId);
      if (list.type === 'cooperationAgreements') {
        await dispatch('company/fetchCooperationAgreements', payload.companyId, { root: true });
      } else {
        await dispatch('fetchEmployees', { companyId: payload.companyId });
      }
      commit(types.STORE_EMPLOYEE_FULFILLED, response);
      dispatch('messages/showMessage', { key: 'alert.updateEntrySuccessful', color: 'success' }, { root: true });
      return true;
    } catch (error) {
      commit(types.STORE_EMPLOYEE_ERROR);
      dispatch('messages/showMessage', { key: 'alert.updateEntryError', color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
  async deleteEmployee({ commit, dispatch }, { payload, list }) {
    commit(types.DELETE_EMPLOYEE_PENDING);
    try {
      const url = `${apiDomain}company/${payload.companyId}/employees/${payload.employee.resume_entry_id}`;
      const response = await axios.delete(url, payload.employee);
      if (list.type === 'cooperationAgreements') {
        await dispatch('company/fetchCooperationAgreements', payload.companyId, { root: true });
      } else {
        await dispatch('fetchEmployees', { companyId: payload.companyId });
      }
      commit(types.DELETE_EMPLOYEE_FULFILLED, response);
      dispatch('messages/showMessage', { key: 'alert.updateEntrySuccessful', color: 'success' }, { root: true });
      return true;
    } catch (error) {
      commit(types.DELETE_EMPLOYEE_ERROR);
      dispatch('messages/showMessage', { key: 'alert.updateEntryError', color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },

  // Employees Assignment
  async fetchEmployeesAssignment({ commit }, id) {
    commit(types.FETCH_EMPLOYEES_ASSIGNMENT_PENDING);
    try {
      const response = await axios.get(`${apiDomain}company/${id}/employees/toapprove`);
      commit(types.FETCH_EMPLOYEES_ASSIGNMENT_FULFILLED, response);
      return true;
    } catch (error) {
      commit(types.FETCH_EMPLOYEES_ASSIGNMENT_ERROR);
      return Promise.reject(error);
    }
  },
  async updateEmployeeAssignment({ commit, dispatch }, payload) {
    commit(types.STORE_EMPLOYEE_ASSIGNMENT_PENDING);
    try {
      const url = `${apiDomain}company/${payload.companyId}/employees/${payload.entryId}/${payload.type}`;
      const response = await axios.post(url, payload.type === 'decline' ? payload.form : null);
      commit(types.STORE_EMPLOYEE_ASSIGNMENT_FULFILLED, response);
      const successMessage = payload.type === 'decline' ? 'alert.declineEmployeeSuccessful' : 'alert.acceptEmployeeSuccessful';
      dispatch('messages/showMessage', { key: successMessage, color: 'success' }, { root: true });
      dispatch('fetchEmployeesAssignment', payload.companyId);
      return true;
    } catch (error) {
      commit(types.STORE_EMPLOYEE_ASSIGNMENT_ERROR);
      const errorMessage = payload.type === 'decline' ? 'alert.declineEmployeeError' : 'alert.acceptEmployeeError';
      dispatch('messages/showMessage', { key: errorMessage, color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },

  // Employees Reenter
  async fetchEmployeesReEnter({ rootState, commit }, id) {
    commit(types.FETCH_EMPLOYEES_REENTER_PENDING);
    try {
      const companyId = id || rootState.company.profile.company.id;
      const response = await axios.get(`${apiDomain}company/${companyId}/employees/torenew`);
      commit(types.FETCH_EMPLOYEES_REENTER_FULFILLED, response);
      return true;
    } catch (error) {
      commit(types.FETCH_EMPLOYEES_REENTER_ERROR);
      return Promise.reject(error);
    }
  },
  async updateEmployeeReEnter({ commit, dispatch }, {
    type,
    companyId,
    employee,
    listType,
  }) {
    commit(types.STORE_EMPLOYEE_REENTER_PENDING);
    try {
      // type = renew|declineRenew
      // TODO: form object
      const payload = {
        start_date: employee.start_date,
        end_date: employee.end_date,
        occupied_job_id: employee.occupied_job_id,
        job_title: employee.job_title,
        workload: employee.workload,
        registration_requirement_status: employee.registration_requirement_status,
      };
      const url = `${apiDomain}company/${companyId}/employees/${employee.resume_entry_id}/${type}`;
      await axios.post(url, payload);
      commit(types.STORE_EMPLOYEE_REENTER_FULFILLED);
      if (listType) {
        dispatch('fetchEmployees', { companyId, listType });
      } else {
        dispatch('fetchEmployeesReEnter', companyId);
      }
      const successMessage = type === 'renew' ? 'alert.renewEmployeeSuccessful' : 'alert.declineRenewEmployeeSuccessful';
      dispatch('messages/showMessage', { key: successMessage, color: 'success' }, { root: true });
      return true;
    } catch (error) {
      commit(types.STORE_EMPLOYEE_REENTER_ERROR);
      const errorMessage = type === 'renew' ? 'alert.declineRenewEmployeeSuccessful' : 'alert.declineRenewEmployeeError';
      dispatch('messages/showMessage', { key: errorMessage, color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
};

export default actions;
